import { gt } from 'semver';
import { readdir } from 'fs';
import { spawnSync } from 'child_process';
import { logger as appLogger } from 'nightingale-app-console';
import { user } from './params';

const logger = appLogger.child('migrate');

(function migrate(previousVersion: string, newVersion: string): Promise<any> {
  return new Promise((resolve: Function, reject: Function) => {
    readdir(`${__dirname}/../../migrate/`, (err: ?any, files: Array<string>) => {
      if (err) {
        return reject(err);
      }

      files
        .filter(file => file.slice(-3) === '.sh')
        .map(file => ({ file, version: /^([^_]+)(_.*).sh$/.exec(file)[1] }))
        .filter(file => gt(file.version, previousVersion))
        .sort((a, b) => gt(a.version, b.version))
        .forEach((file: { version: string, file: string }) => {
          logger.info('migrate', file);
          try {
            spawnSync('sh', [file.file], {
              cwd: `${__dirname}/../../migrate/`,
              env: { ...process.env, POOLIOT_USER: user },
              stdio: 'inherit',
            });
            logger.infoSuccess('success', file);
          } catch (err) {
            logger.error(err);
          }
        });
    });
  });
})(process.argv[2], process.argv[3])
  .then(() => logger.infoSuccess('migration done'))
  .catch(err => console.log(err.stack || err.message || err));
